import styled from "styled-components";
import customMedia from "../../config/breakpoints";

export const StyledUrgencyButton = styled.a`
  background: none;
  border: 1px solid ${({ theme }) => theme.colors.red};
  border-radius: 4px;
  display: flex;
  color: ${({ theme }) => theme.colors.red};
  cursor: pointer;
  font-family: Aileron;
  font-size: 14px;
  font-weight: 700;
  padding: 1rem 1.5rem;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    border: 4px solid ${({ theme }) => theme.colors.orange};
    text-decoration: underline;
  }
  ${customMedia.lessThan("mobile")`
    padding: 8px;
  `}
`;
